// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import withStyles from '../../../../../../common/hoc/withStyles';
import EarnExtraPointsTileContainer from '../../EarnExtraPointsTile';
import { getSessionStorage } from '../../../../../../../utils';

/**
 *
 * @function EarnExtraPointsOverview
 * @description renders the Earn Extra Points component on Account Overview
 */
const EarnExtraPointsOverview = () => {
  const isNewlyCreatedUser = getSessionStorage('isNewlyCreatedUser');

  return isNewlyCreatedUser && <EarnExtraPointsTileContainer isAccountOverview />;
};

EarnExtraPointsOverview.propTypes = {};

EarnExtraPointsOverview.defaultProps = {};
export default withStyles(EarnExtraPointsOverview);
